// extracted by mini-css-extract-plugin
module.exports = {"select":"Select-styles_select__3SHai"};